import { SocietyCorporateId } from 'types/Society';

export const configsByCorporateId: Record<SocietyCorporateId, any> = {
  [SocietyCorporateId.DEFAULT]: {
    hasAdminDomainsLimited: false,
    allowedAdminEmailDomains: [],
    hasBasicBoardEntityType: false,
    hasPartnerBookEnabled: true,
  },
  [SocietyCorporateId.AXA]: {
    hasAdminDomainsLimited: true,
    allowedAdminEmailDomains: ['axa.es', 'sttok.com'],
    hasBasicBoardEntityType: true,
    hasPartnerBookEnabled: false,
  },
};
